import request from '@/utils/request'
import { machineryMgtAppCode as appCode } from '@/utils/dictionaries'

/**
 * 进度管理-总统计
 * @param parameter
 * @returns {*}
 */
 export function ProgressReportCount (parameter) {
  return request({
    url: 'beam/Beam/overallProgressStatistics',
    method: 'get',
    params: parameter
  })
}
/**
 * 进度管理-列表
 * @param parameter
 * @returns {*}
 */
 export function ProgressReportList (parameter = {}) {
  return request({
    url: 'beam/Beam/beamModelProgressStatistics',
    method: 'get',
    params: parameter
  })
}
/**
 * 进度管理-制梁进度分析
 * @param parameter
 * @returns {*}
 */
 export function getBeamProgressAnalysis (parameter) {
  return request({
    url: 'beam/Beam/beamProgressAnalysis',
    method: 'get',
    params: parameter
  })
}
/**
 * 进度管理-架梁进度分析
 * @param parameter
 * @returns {*}
 */
 export function getErectionProgressAnalysis (parameter) {
  return request({
    url: 'beam/Beam/erectionProgressAnalysis',
    method: 'get',
    params: parameter
  })
}
/**
 * 桥段-保存
 * @param parameter
 * @property {String} name 桥段名称
 * @returns {*}
 */
 export function savePlot (parameter = {}) {
  return request({
    url: '/beam/Bridge/',
    method: 'post',
    data: parameter
  })
}
/**
 * 桥段-编辑
 * @param {object} parameter
 * @property {String} id	唯一标识
 * @property {String} name	桥段名称
 */
 export function updatePlot (parameter) {
  return request({
    url: `/beam/Bridge/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【无人机】列表
 * @param {object} parameter
 */
 export function getUavList (parameter) {
  return request({
    url: `/AY220052Z/UavRecord/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【无人机】删除
 * @param {object} parameter
 */
 export function delUav (parameter) {
  return request({
    url: `/AY220052Z/UavRecord/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【无人机】保存
 * @param {object} parameter
 */
 export function saveUav (parameter) {
  return request({
    url: `/AY220052Z/UavRecord/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【无人机】编辑
 * @param {object} parameter
 */
 export function putUav (parameter) {
  return request({
    url: `/AY220052Z/UavRecord/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【无人机】查看
 * @param {object} parameter
 */
 export function getUav (parameter) {
  return request({
    url: `/AY220052Z/UavRecord/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【进度编制与管控-资源库配置】保存
 * @param {object} parameter
 */
export function saveResourcePool (parameter) {
  return request({
    url: `/AY220052Z/ResourcePool/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【进度编制与管控-资源库配置】修改
 * @param {object} parameter
 */
export function updateResourcePool (parameter) {
  return request({
    url: `/AY220052Z/ResourcePool/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【进度编制与管控-资源库配置】列表
 * @param {object} parameter
 */
export function getResourcePoolList (parameter) {
  return request({
    url: `/AY220052Z/ResourcePool/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【进度编制与管控-资源库配置】详细
 * @param {object} parameter
 */
export function getResourcePool (parameter) {
  return request({
    url: `/AY220052Z/ResourcePool/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【进度编制与管控-资源库配置】删除
 * @param {object} parameter
 */
export function delResourcePool (parameter) {
  return request({
    url: `/AY220052Z/ResourcePool/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【进度编制与管控-工程量库配置】保存
 * @param {object} parameter
 */
export function saveEngineeringQuantityPool (parameter) {
  return request({
    url: `/AY220052Z/EngineeringQuantityPool/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【进度编制与管控-工程量库配置】修改
 * @param {object} parameter
 */
export function updateEngineeringQuantityPool (parameter) {
  return request({
    url: `/AY220052Z/EngineeringQuantityPool/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【进度编制与管控-工程量库配置】列表
 * @param {object} parameter
 */
export function getEngineeringQuantityPoolList (parameter) {
  return request({
    url: `/AY220052Z/EngineeringQuantityPool/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【进度编制与管控-工程量库配置】详细
 * @param {object} parameter
 */
export function getEngineeringQuantityPool (parameter) {
  return request({
    url: `/AY220052Z/EngineeringQuantityPool/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【进度编制与管控-工程量库配置】删除
 * @param {object} parameter
 */
export function delEngineeringQuantityPool (parameter) {
  return request({
    url: `/AY220052Z/EngineeringQuantityPool/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【进度横道图】列表
 * @param {object} parameter
 */
export function preparationTreeList (parameter) {
  return request({
    url: `/AY220052Z/ProgressPreparationControl/preparationTreeList`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【进度横道图】进度计划列表
 * @param {object} parameter
 */
export function progressPlanManageList (parameter) {
  return request({
    url: `/AY220052Z/ProgressPlanManage/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【进度编制与管控】导入记录
 * @param {object} parameter
 */
export function ImportRecords (parameter) {
  return request({
    url: `/file/ImportRecords/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【进度编制与管控】保存
 * @param {object} parameter
 */
export function saveProgressPreparationControl (parameter) {
  return request({
    url: `/AY220052Z/ProgressPreparationControl/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【进度编制与管控】保存
 * @param {object} parameter
 */
export function putProgressPreparationControl (parameter) {
  return request({
    url: `/AY220052Z/ProgressPreparationControl/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【进度编制与管控】查看
 * @param {object} parameter
 */
export function getProgressPreparationControl (parameter) {
  return request({
    url: `/AY220052Z/ProgressPreparationControl/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【进度编制与管控】删除
 * @param {object} parameter
 */
export function delProgressPreparationControl (parameter) {
  return request({
    url: `/AY220052Z/ProgressPreparationControl/${parameter.id}`,
    method: 'delete'
  })
}
/**
 * 【进度编制与管控】导入
 */
export function importExcel (parameter) {
  return request({
    url: `/file/excel/importExcel`,
    method: 'post',
    data: parameter,
    timeout: 15000
  })
}
/**
 * 【进度编制与管控】结构调整
 */
export function structuralAdjustment (parameter) {
  return request({
    url: `/AY220052Z/ProgressPreparationControl/structuralAdjustment`,
    method: 'post',
    data: parameter
  })
}

// #region --------------------------进度编制------------------------------

/**
 * 导入
 */
export function importExcelSchedule (parameter) {
  return request({
    url: `/machineryMgt/file/excel/importExcel`,
    method: 'post',
    data: parameter,
    timeout: 60000
  })
}

/**
 * 导出
 */
export function exportExcelSchedule (parameter) {
  return request({
    url: `/machineryMgt/file/excel/exportExcel`,
    method: 'post',
    data: parameter,
    timeout: 15000
  })
}

/**
 * 查看导入记录列表
 */
export function listMachineryFileImportRecord (parameter) {
  return request({
    url: `/machineryMgt/file/FileImportRecord/listFileImportRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改进度编制
 */
export function putScheduleDevelopment (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/`,
    method: 'put',
    data: Object.assign({ appCode }, parameter)
  })
}

/**
 * 查询进度编制列表
 */
export function getScheduleDevelopmentList (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/list`,
    method: 'get',
    params: Object.assign({ appCode }, parameter)
  })
}

/**
 * 保存进度编制
 */
export function postSaveScheduleDevelopment (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/saveScheduleDevelopment`,
    method: 'post',
    data: parameter
  })
}

/**
 * 查询进度编制详情
 */
export function getScheduleDevelopment (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 根据id删除进度编制
 */
export function deleteScheduleDevelopment (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 根据id批量删除进度编制
 */
export function batchDeleteScheduleDevelopment (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/batchDelete/${parameter.ids}`,
    method: 'delete'
  })
}

/**
 * 查询进度编制排序配置列表
 */
export function listScheduleDevelopmentSort (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopmentSort/listScheduleDevelopmentSort`,
    method: 'get',
    params: Object.assign({ appCode }, parameter)
  })
}

/**
 * 查询进度编制构件部位列表
 */
export function getComponentPartList (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/getComponentPartList/${appCode}/${parameter.orgId}`,
    method: 'get'
  })
}

/**
 * 保存进度编制排序配置
 */
export function saveScheduleDevelopmentSort (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopmentSort/saveScheduleDevelopmentSort`,
    method: 'post',
    data: Object.assign({ appCode }, parameter)
  })
}

/**
 * 查询进度编制分组配置详情
 */
export function getScheduleDevelopmentGroupById (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopmentGroup/getScheduleDevelopmentGroupById/${appCode}/${parameter.orgId}`,
    method: 'get'
  })
}

/**
 * 保存进度编制分组配置
 */
export function saveScheduleDevelopmentGroup (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopmentGroup/saveScheduleDevelopmentGroup`,
    method: 'post',
    data: Object.assign({ appCode }, parameter)
  })
}

/**
 * 批量完成进度编制
 * @param {Object} parameter - 请求参数
 */
export function batchCompleteScheduleDevelopment (parameter) {
  return request({
    url: `/machineryMgt/sys/ScheduleDevelopment/batchComplete`,
    method: 'post',
    data: parameter
  })
}

/**
 * 左右洞近七日进度(通用)
 */
export function getNearSevenDay (parameter) {
  return request({
    url: `/iot/TunnelProgressData/getNearSevenDay`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询隧道进度管理列表
 */
export function getTunnelProgressDataList (parameter) {
  return request({
    url: `/iot/TunnelProgressData/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 根据id删除隧道进度管理
 */
export function deleteTunnelProgress (parameter) {
  return request({
    url: `/iot/TunnelProgressData/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 查看隧道进度管理
 */
export function getTunnelProgressInfo (parameter) {
  return request({
    url: `/iot/TunnelProgressData/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 保存隧道进度管理
 */
export function saveTunnelProgress (parameter) {
  return request({
    url: `/iot/TunnelProgressData/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 保存隧道进度管理
 */
export function updateTunnelProgress (parameter) {
  return request({
    url: `/iot/TunnelProgressData/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 隧道信息树（隧道进度左侧导航）
 */
export function listTunnelInfoTree (parameter) {
  return request({
    url: `/iot/TunnelInfo/listTunnelInfoTree`,
    method: 'get',
    params: parameter
  })
}

/** 隧道名称 / 分段详情 */
export function getTunnelInfoById (parameter) {
  return request({
    url: `/iot/TunnelInfo/getTunnelInfoById/${parameter.id}`,
    method: 'get'
  })
}

/** 新增隧道名称 */
export function saveTunnelInfo (parameter) {
  return request({
    url: `/iot/TunnelInfo/saveTunnelInfo`,
    method: 'post',
    data: parameter
  })
}

/** 新增分段开挖标识 */
export function saveTunnelSegment (parameter) {
  return request({
    url: `/iot/TunnelInfo/saveTunnelSegment`,
    method: 'post',
    data: parameter
  })
}

/** 编辑隧道名称 */
export function updateTunnelInfo (parameter) {
  return request({
    url: `/iot/TunnelInfo/updateTunnelInfo`,
    method: 'put',
    data: parameter
  })
}

/** 编辑分段开挖标识 */
export function updateTunnelSegment (parameter) {
  return request({
    url: `/iot/TunnelInfo/updateTunnelSegment`,
    method: 'put',
    data: parameter
  })
}

/** 删除隧道名称或分段开挖标识 */
export function deleteTunnelInfoById (parameter) {
  return request({
    url: `/iot/TunnelInfo/deleteTunnelInfoById/${parameter.id}`,
    method: 'delete'
  })
}

// #endregion

// #region --------------------------梁进度管理------------------------------

/**
 * 查询进度指标设置列表
 */
export function getProgressIndicatorConfigList (parameter) {
  return request({
    url: `/beam/ProgressIndicatorConfig/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改进度指标设置
 */
export function putProgressIndicatorConfig (parameter, orgId) {
  return request({
    url: `/beam/ProgressIndicatorConfig/?orgId=${orgId}`,
    method: 'put',
    data: parameter
  })
}

/**
 * 总体进度统计
 */
export function getOverallProgressStatistics (parameter) {
  return request({
    url: `/beam/ProgressIndicatorConfig/beamOverallProgressStatistics`,
    method: 'get',
    params: parameter
  })
}

/**
 * 梁型进度统计
 */
export function getBeamModelProgressStatistics (parameter) {
  return request({
    url: `/beam/ProgressIndicatorConfig/beamModelProgressStatistics`,
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------项目施工日志------------------------------

/**
 * 查询项目施工日志列表
 */
export function getProjectConstructionRecordList (parameter) {
  return request({
    url: `/materials/ProjectConstructionRecord/listProjectConstructionRecord`,
    method: 'get',
    params: parameter
  })
}
/**
 * 查询项目施工日志详情
 * @param {object} parameter
 */
export function getProjectConstructionRecordById (parameter) {
  return request({
    url: `/materials/ProjectConstructionRecord/getProjectConstructionRecordById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 查询劳务人员情况列表
 * @param {object} parameter
 */
export function getWorkerLaborList (parameter) {
  return request({
    url: `/org/Organization/workerLaborList`,
    method: 'get',
    params: parameter
  })
}

/**
 * 新增单据记录
 * @param {object} parameter
 */
export function updateProjectConstructionRecord (parameter) {
  return request({
    url: `/materials/ProjectConstructionRecord/updateProjectConstructionRecord`,
    method: 'put',
    data: parameter
  })
}

// #endregion
